import { NavigationSection } from "@common/data-models/service/navigation-section";
import { IDeepCopy } from "@common/interfaces/i-deep-copy";
import { Util } from "@common/utils/util";

export class NavigationGroup implements IDeepCopy<NavigationGroup> {

    public static SYSTEM: number = -1;
    public static GLOBAL: number = 1;
    public static TEAM: number = 2;
    public static PERSONAL: number = 3;

    public ID: number;
    public Label: string;
    public Order: number;
    public Items: Array<NavigationSection> = [];
    public Opened: boolean = false;

    public get system(): boolean {
        return (this.ID < 0) ? true : false;
    }

    public open() {
        this.Opened = true;
    }

    public close() {
        this.Opened = false;
    }

    public toggle() {
        this.Opened = !this.Opened;
    }

    public deepCopy(): NavigationGroup {
        let group = new NavigationGroup();
        group.ID = this.ID;
        group.Label = this.Label;
        group.Order = this.Order;
        group.Opened = this.Opened;
        group.Items = [];
        for (let item of this.Items) {
            group.Items.push(item.deepCopy());
        }
        return group;
    }

    public get isTeamGroup() {
        return this.ID == NavigationGroup.TEAM;
    }
}
